class AnnouncementTicker {
  constructor(element) {
    this.wrapper = element;
    this.ticker = this.wrapper.querySelector('.announcement-ticker');
    if (this.ticker) {
      this.init();
    }
  }

  init() {
    // Apply settings are already in inline styles, no need to do anything
    // Just handle window resize for responsive behavior
    this.handleResize();
  }

  handleResize() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Force reflow to ensure animation continues smoothly
        if (this.ticker) {
          this.ticker.style.animation = 'none';
          setTimeout(() => {
            this.ticker.style.animation = '';
          }, 10);
        }
      }, 250);
    });
  }
}

// Initialize all announcement tickers on the page
function initTickers() {
  const tickers = document.querySelectorAll('.announcement-ticker-wrapper');
  tickers.forEach(ticker => {
    if (!ticker.dataset.initialized) {
      new AnnouncementTicker(ticker);
      ticker.dataset.initialized = 'true';
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTickers);
} else {
  initTickers();
}

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const ticker = event.target.querySelector('.announcement-ticker-wrapper');
    if (ticker) {
      ticker.dataset.initialized = 'false';
      new AnnouncementTicker(ticker);
    }
  });

  document.addEventListener('shopify:section:reorder', () => {
    initTickers();
  });
  
  document.addEventListener('shopify:block:select', () => {
    initTickers();
  });
}

